$(".woocommerce-billing-fields__field-wrapper").ready(function () { // page loaded
    //--------------------------- INSTANTIATE STATE -------------------------------------------------
    if ($(".woocommerce-cart").length) { // on the cart page

        if ($("select.shipping_method").length) {
            setTimeout(() => {
                $(".ship-box").addClass("show-after");  
            }, 800);

        } else {
            setTimeout(() => {
                $(".ship-box").removeClass("show-after");
            }, 800);

        }
    }

    if ($(".woocommerce-checkout").length) { // on the checkout page

        if ($("select.shipping_method").length) { 
            setTimeout(() => {
                $(".shipping-title").addClass("show-after");
            }, 800);
        } else {
            setTimeout(() => {
                $(".shipping-title").removeClass("show-after");
            }, 800);
        }
    }

    let wrapper = $(".woocommerce-billing-fields__field-wrapper");

    if (wrapper) {
        $("select").on("change", function () {  // if a select changed look at some things

            setTimeout(() => { // let woocommerce compute its things

                if ($(".woocommerce-cart").length) { // do things on the cart page
                    
                    if ($(".shipping_method")) {
                        setTimeout(() => {
                            $(".ship-box").addClass("show-after");
                        }, 800);

                    } else {
                        setTimeout(() => {
                            $(".ship-box").removeClass("show-after");
                        }, 800);

                    }
                }

                if ($(".woocommerce-checkout").length) { // do things on the checkout page
                    
                    if ($(".shipping_method").type() != "hidden"  ) {
                        setTimeout(() => {
                            $(".shipping-title").addClass("show-after");
                        }, 800);

                    } else {
                        setTimeout(() => {
                            $(".shipping-title").removeClass("show-after");
                        }, 800);

                    }
                }
            }, 1000);               
        })
    }
});